import { Message } from '@/utils/Message'

/**
 * Created by jiachenpan on 16/11/18.
 */

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * 小写
 * @param str
 * @returns {boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * 全部大写
 * @param str
 * @returns {boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * 字母
 * @param str
 * @returns {boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

export function validEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * 校验字母数值
 * @param code
 * @returns {boolean}
 */
export function validUserCode(code) {
  const reg = /^[A-Za-z0-9]+$/
  return reg.test(code)
}

export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

export function isBoolean(value) {
  if (typeof value === 'boolean' || value instanceof Boolean) {
    return true
  }
  return false
}

export function isNumber(value) {
  // const re = /^(0|[1-9][0-9]*)$/
  // 正数、负数、小数
  const re = /^(\-|\+)?\d+(\.\d+)?$/
  return re.test(value)
}

export function isNumber2(value) {
  // const re = /^(0|[1-9][0-9]*)$/
  // 正数、负数、小数
  const re = /^(\-|\+)?(0|[1-9]\d*|([1-9]\d*)(\.\d+)|0(\.\d+)){1}$/
  return re.test(value)
}

// 正数
export function isPositiveNumber(value) {
  const re = /^(([1-9]\d*)+(\.\d+)?|0\.\d*)?$/
  return re.test(value)
}
// 正整数
export function isPositiveInteger(value) {
  const re = /^[1-9]\d*$/
  return re.test(value)
}

/**
 * 校验英文(排除汉字)
 * @param value
 * @returns {boolean}
 */
export function validEnglishWords(value) {
  const re = /[^\x00-\xff]/g // GBK 中文  一个用16进制指定的字符(占一个字节)
  return re.test(value)
}
/**
 * 是数组Array
 * @param arg
 * @returns {*}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

/**
 * 是否为对象
 * @param arg
 * @returns {*}
 */
export function isJsonObj(arg) {
  return Object.prototype.toString.call(arg) === '[object Object]'
}

export function validIp(str) {
  return /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/.test(str)
}

/**
 * 断言类，辅助表单校验
 */
export class Assert {
  static async isTrue(flag, message, type = 'error') {
    if (!flag) {
      Message({ message, type })
      return Promise.reject({ message, type })
    }
  }
  // Falsy值包括：false、undefined、null、正负0、NaN、”"。
  static async isFalsy(value, message, type = 'error') {
    if (value) {
      Message({ message, type })
      return Promise.reject({ message, type })
    }
  }
  // 空数组、空字符串、空对象、null、undefined、
  static async isNotBlank(value, message, type = 'error') {
    const valueType = Object.prototype.toString.call(value)
    let flag = false
    if (value === undefined || value === null) {
      flag = true
    }
    if (!flag) {
      switch (valueType) {
        case '[object Array]':
          flag = value.length === 0
          break
        case '[object Object]':
          flag = Object.keys(value).length === 0
          break
        case '[object String]':
          flag = value.trim().length === 0
          break
      }
    }
    if (flag) {
      Message({ message, type })
      return Promise.reject({ message, type })
    }
  }
  // 空数组、空字符串、空对象、null、undefined、
  static async isNumber(value, message, type = 'error') {
    if (!isNumber(value)) {
      Message({ message, type })
      return Promise.reject({ message, type })
    }
  }
  // todo 可以扩展 isTel,isEmail 等等
}
